import {
  getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationKey,
  getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditMutationFetcher,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';
import type { Key } from 'swr';

/**
 * 利用企業への与信を付与する hook
 *
 * - 一覧画面から trigger(clientId) で clientId を渡すパターン（trigger 経由パターン）
 *   stale closure バグを防ぐため hook 生成時に ID を固定せず、実行時に渡す
 * - mutation key は同リソースの POST key を流用する（安定キー）
 *
 * @param threeLetterCode - パートナーの 3 文字コード
 * @param options - コールバックオプション
 * @param options.onSuccess - 成功時のコールバック
 * @param options.onError - エラー時のコールバック
 */
export const usePutPartnerAdminsClientGrantCredit = (
  threeLetterCode: string,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  return useMutation(
    getPostApiV1ThreeLetterCodePartnerAdminsClientsMutationKey(threeLetterCode),
    (_: Key, { arg }: { arg: number }) =>
      getPutApiV1ThreeLetterCodePartnerAdminsClientsClientIdGrantCreditMutationFetcher(
        threeLetterCode,
        arg
      ),
    options
  );
};
